// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  color: #ffffff;
  border: none;
}

.career {
  padding-bottom: 30px;
}
.career p {
  text-align: left;
  padding: 20px 0;
}
.career .nav-tabs {
  border: none;
}
.career .nav-tabs .nav-item button {
  color: #ffffff;
  border: none;
  isolation: revert;
  padding: 0;
  margin-right: 20px;
  font-size: 24px;
}
.career .nav-tabs .nav-item button:hover,
.career .nav-tabs .nav-item button:focus,
.career .nav-tabs .nav-item button:visited,
.career .nav-tabs .nav-item button:focus-within {
  border: none;
  transition: none;
  isolation: revert;
}
.career .nav-tabs .nav-item button.active {
  border: none;
  transition: none;
  background: none;
  border-bottom: 1px solid #ffffff;
}
.career .tab-content div {
  text-align: left;
  padding-top: 10px;
} `, "",{"version":3,"sources":["webpack://./src/components/Career/career.scss","webpack://./src/components/Career/career.css"],"names":[],"mappings":"AAAA;EACE,SAAA;EACA,UAAA;EAEA,cAAA;EACA,YAAA;ACAF;;ADEA;EACE,oBAAA;ACCF;ADAE;EACE,gBAAA;EACA,eAAA;ACEJ;ADAE;EACE,YAAA;ACEJ;ADAM;EACE,cAAA;EACA,YAAA;EACA,iBAAA;EACA,UAAA;EACA,kBAAA;EACA,eAAA;ACER;ADAQ;;;;ECKR,YAAA;EDGQ,gBAAA;EACE,iBAAA;ACDV;AACA;EDGU,YAAA;ECDV,gBAAA;EDOI,gBAAA;EACE,gCAAA;ACLN;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB","sourcesContent":["* {\n  margin: 0;\n  padding: 0;\n\n  color: #ffffff;\n  border: none;\n}\n.career {\n  padding-bottom: 30px;\n  p {\n    text-align: left;\n    padding: 20px 0;\n  }\n  .nav-tabs {\n    border: none;\n    .nav-item {\n      button {\n        color: #ffffff;\n        border: none;\n        isolation: revert;\n        padding: 0;\n        margin-right: 20px;\n        font-size: 24px;\n\n        &:hover,\n        &:focus,\n        &:visited,\n        &:focus-within {\n          border: none;\n          transition: none;\n          isolation: revert;\n        }\n        &.active {\n          border: none;\n          transition: none;\n          background: none;\n          border-bottom: 1px solid #ffffff;\n        }\n      }\n    }\n  }\n  .tab-content {\n    div {\n      text-align: left;\n      padding-top: 10px;\n    }\n  }\n}\n","* {\n  margin: 0;\n  padding: 0;\n  color: #ffffff;\n  border: none;\n}\n\n.career {\n  padding-bottom: 30px;\n}\n.career p {\n  text-align: left;\n  padding: 20px 0;\n}\n.career .nav-tabs {\n  border: none;\n}\n.career .nav-tabs .nav-item button {\n  color: #ffffff;\n  border: none;\n  isolation: revert;\n  padding: 0;\n  margin-right: 20px;\n  font-size: 24px;\n}\n.career .nav-tabs .nav-item button:hover,\n.career .nav-tabs .nav-item button:focus,\n.career .nav-tabs .nav-item button:visited,\n.career .nav-tabs .nav-item button:focus-within {\n  border: none;\n  transition: none;\n  isolation: revert;\n}\n.career .nav-tabs .nav-item button.active {\n  border: none;\n  transition: none;\n  background: none;\n  border-bottom: 1px solid #ffffff;\n}\n.career .tab-content div {\n  text-align: left;\n  padding-top: 10px;\n} /*# sourceMappingURL=career.css.map */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
